package gr.tech.pdfgenerator.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import gr.tech.pdfgenerator.infrastructure.data.GeneratorData
import gr.tech.pdfgenerator.util.INPUTS
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun projectDetailsInputs() {
    var generalInputState by GeneratorData.generalInputsState
    var projectInputsState by GeneratorData.project

    Row(
        modifier = Modifier
            .padding(bottom = 6.px)
            .margin(bottom = 6.px)
            .gap(16.px)
            .width(600.px)
    ) {
        Column(
            modifier = Modifier
                .width(50.percent)
        ) {
            StringInputLabel(
                label = "Project Name",
                id = INPUTS.GENERAL.projectNameInput,
                initialValue = generalInputState.projectName
            ) {
                generalInputState = generalInputState.copy(projectName = it)
            }
        }

        Column(
            modifier = Modifier
                .width(50.percent)
        ) {
            StringInputLabel(
                label = "Salesforce Deal Name",
                id = INPUTS.GENERAL.salesforceDealNameInput,
                initialValue = generalInputState.salesforceDealName
            ) {
                generalInputState = generalInputState.copy(salesforceDealName = it)
            }
        }
    }

    Row(
        modifier = Modifier
            .padding(bottom = 6.px)
            .margin(bottom = 6.px)
            .gap(16.px)
            .width(600.px)
            .borderBottom(2.px, LineStyle.Solid, Colors.LightGrey)
    ) {
        TextAreaInputLabel(
            label = "Project Description & Notes",
            id = INPUTS.GENERAL.projectDescriptionInput,
            initialValue = GeneratorData.project.value.description
        ) {
            projectInputsState = projectInputsState.copy(description = it)
        }
    }
}